(ns common.schema.entities.reminder-rule.schema
  (:require
   [common.schema.entities.reminder-rule.options :as options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :reminder-rule/rule-label
                          "Label"
                          {:authorization            su/access-user-user
                           :default-field-visibility :in-use-disabled
                           ;; See the note on the rotation period label - this is
                           ;; the entity's display name.
                           :mandatory-config         :mandatory/always})
    (su/keyword-field :reminder-rule/reminder-anchor
                      "Reminder anchor"
                      options/reminder-anchor-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled
                       ;; Without an anchor `reminder-anchor-at` resolves nil,
                       ;; so the rule never schedules anything and says nothing
                       ;; about it.
                       :mandatory-config         :mandatory/always})
    (su/keyword-field :reminder-rule/offset-direction
                      "Offset direction"
                      options/offset-direction-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled
                       ;; Mandatory so the direction is always an explicit
                       ;; choice. It used to be carried by the sign of
                       ;; `offset-value`, which the form never explained: typing
                       ;; 2 for "two days before the deadline" scheduled the
                       ;; reminder two days after it, silently.
                       :mandatory-config         :mandatory/always})
    (su/keyword-field :reminder-rule/offset-type
                      "Offset type"
                      options/offset-type-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled
                       ;; Without a unit the multiplier lookup falls back to 0,
                       ;; which silently discards the offset value and fires the
                       ;; reminder exactly on its anchor.
                       :mandatory-config         :mandatory/always})
    (su/integer-field :reminder-rule/offset-value
                      "Offset value"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/keyword-field :reminder-rule/reminder-rule-status
                      "Status"
                      options/reminder-rule-status-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled}))))
